// import React, { useState, useEffect } from "react";
// import '../assets/css/style.css';
// import queryString from 'query-string';

// const splashBG = {
//   light: '#fff',
//   dark: "#2d2d2d"
// };

// function SplashMessage(props) {
//   let background = splashBG[props.brand_theme];

//   return (
//     <div className="splash-container" style={{ backgroundColor: background }}>
//       <img src={props.brand_image_url} className="App-logo" alt="logo" />
//     </div>
//   );
// }

// export default function withSplashScreen(WrappedComponent) {
//   let currentPath = window.location.pathname;

//   console.log('currentPath', currentPath);

//   return function SplashScreenWrapper(props) {
//     // Unconditionally initialize hooks
//     const [loading, setLoading] = useState(true);
//     const [params, setParams] = useState(null);

//     useEffect(() => {
//       if (currentPath !== '/') {
//         // Parse query params only if not on '/' route
//         let { params: queryParams } = queryString.parse(window.location.search);

//         queryParams = decodeURIComponent(queryParams);

//         if (queryParams) {
//           queryParams = JSON.parse(queryParams);
//           setParams(queryParams); // Store parsed params in state
//         }

//         // Set timeout for splash screen loading
//         const timer = setTimeout(() => {
//           setLoading(false);
//         }, 2000);

//         return () => clearTimeout(timer);
//       } else {
//         // If on '/' path, no loading state and no params needed
//         setLoading(false);
//       }
//     }, [currentPath]);

//     // Default values for params
//     const { brand_theme, brand_image, branding, url } = params || {};
//     let image_url = 'https://plexmedia-sm-asset-storage.s3.ap-east-1.amazonaws.com/data/plex_brand_dark_theme_logo.png';
//     let theme = 'dark';

//     if (branding) {
//       image_url = brand_image[brand_theme];
//     }

//     if(brand_theme){
//       theme = brand_theme;
//     }

//     // Conditional rendering: If currentPath is '/', render WrappedComponent immediately
//     if (currentPath === '/') {
//       return <WrappedComponent {...props} />;
//     }

//     // Show splash screen while loading
//     if (loading) {
//       return <SplashMessage brand_image_url={image_url} brand_theme={theme} />;
//     }

//     // Once loading is done, render WrappedComponent with params
//     return <WrappedComponent game_launch_url={url} {...props} />;
//   };
// }

import React, { useState, useEffect } from "react";
import '../assets/css/style.css';
import queryString from 'query-string';

const splashBG = {
  light: '#fff',
  dark: "#2d2d2d"
};

function SplashMessage(props) {
  let background = splashBG[props.brand_theme];

  return (
    <div className="splash-container" style={{ backgroundColor: background }}>
      <img src={props.brand_image_url} className="App-logo" alt="logo" />
    </div>
  );
}

export default function withSplashScreen(WrappedComponent) {
  const currentPath = window.location.pathname;


  return function SplashScreenWrapper(props) {
    const [loading, setLoading] = useState(true);


    const queryParams = queryString.parse(window.location.search);
    const branding = queryParams.branding === 'true';
    const brand_theme = queryParams.brand_theme || 'dark';
    const brand_image_light = queryParams.brand_image_light;
    const brand_image_dark = queryParams.brand_image_dark;
    const decodedUrl = queryParams.url ? decodeURIComponent(queryParams.url) : null;


    useEffect(() => {
      if (currentPath === '/') {
        setLoading(false);
        return;
      }


      if (!branding) {
        setLoading(false);
        return;
      }


      const timer = setTimeout(() => setLoading(false), 2000);
      return () => clearTimeout(timer);
    }, [currentPath, branding]);


    if (currentPath === '/') {
      return <WrappedComponent {...props} />;
    }

    if (loading && branding) {

      const DEFAULT_LOGO = 'https://plexmedia-sm-asset-storage.s3.ap-east-1.amazonaws.com/plexmedia-sm-asset-storage/1757442908368-1757442907730-mainlogo.png';

      const image_url = brand_theme === 'light' ? (brand_image_light || DEFAULT_LOGO) : (brand_image_dark || DEFAULT_LOGO);

      return <SplashMessage brand_image_url={image_url} brand_theme={brand_theme} />;
    }

    return <WrappedComponent game_launch_url={decodedUrl} {...props} />;
  };
}

